/**
 * 站点首页 — 繁體中文（PC / M 共用，對應 t('index.…')）
 */
export default {
	energy: {
		title: "今日能量",
		mohu: "登入後，解鎖各項能量值",
		todayLabel: "今日能量",
		tip: "今日不宜裝修改動，建議栽種花草調整磁場，有助提升整體氣場能量。",
		viewDetail: "查看今日能量詳解",
		supplementProfile: "請補充檔案信息",
		addProfile: "添加檔案後，查看各項能量值",
		categories: {
			emotion: "感情",
			career: "事業",
			wealth: "財運",
			travel: "出行",
			health: "健康",
		},
		ts: {
			title: "通勝",
			good: "宜",
			bad: "忌",
			viewAll: "查看完整通勝",
			ganzhi: {
				year: "年",
				month: "月",
				day: "日",
			},
		},
	},
	masters: {
		greeting: "你好，我能為您解答什麼人生問題？",
		placeholder: "請輸入你的問題...",
		guide: {
			line1: "全球首創 AI 智慧",
			line2: "夥伴—MasterS",
		},
		tags: {
			bazi: "八字",
			tarot: "塔羅",
			liuyao: "六爻",
			chat: "聊天",
		},
	},
	teacherConsultation: {
		title: "全球專業導師",
		title2: "匯聚世界各地專業導師，指引人生方向",
		consultButton: "查看詳情",
		consultButton2: "立即諮詢",
		defaultName: "老師",
		defaultTags: {
			emotion: "感情解析",
			wealth: "財富分析",
			life: "人生導航",
		},
		summary: {
			years: "從業{year}年",
			users: "服務超過{users}用戶",
			fallback: "專業導師，提供一對一諮詢服務",
		},
	},
	fameTeacher: {
		title: "依人氣、領域分類，快速找到適合你的專業導師推薦",
		title1: "人氣導師排行",
		title2: "選擇你想諮詢的主題",
		consultUnit: "人諮詢",
		viewTeachers: "查看導師",
		viewMore: "查看更多導師",
		join: {
			title: "申請成為導師",
			desc: "分享您的專業，幫助更多人開啟人生新方向",
			button: "立即申請成為導師",
			buttonMobile: "立即申請",
		},
		stats: {
			masters: {
				value: "200+",
				label: "專業導師",
			},
			privacy: {
				value: "隱私保障",
				label: "諮詢內容保密",
			},
			satisfaction: {
				value: "高滿意度",
				label: "真實用戶好評",
			},
			users: {
				value: "200萬+",
				label: "核心用戶",
			},
		},
		topics: {
			love: {
				title: "愛情人際",
				desc: "感情困擾、桃花運勢、人際關係，專業導師為你解惑",
			},
			career: {
				title: "職業財富",
				desc: "事業發展、財運分析、職場困境，指引前行方向",
			},
			health: {
				title: "家庭健康",
				desc: "家庭和睦、身心健康、親子關係，溫暖陪伴與建議",
			},
			decision: {
				title: "決策問事",
				desc: "重大抉擇、人生轉折、疑難問題，助你做出明智決定",
			},
		},
	},
	more: {
		box1: {
			title: "專業測算工具",
			title2: "多維度解析生命軌跡，掌握人生方向",
			useButton: "前往使用",
			bazi: {
				title: "八字排盤",
				desc1: "精準排盤，分析命局五行",
				desc2: "十神格局，運勢深度解析",
			},
			tarot: {
				title: "塔羅占卜",
				desc1: "78張塔羅牌，精準占卜",
				desc2: "愛情、事業、運勢全解析",
			},
		},
		box2: {
			title: "AI+大模型測算",
			items: {
				love: {
					title: "愛情指引",
					desc1: "解析關係模式",
					desc2: "遇見對的人",
				},
				career: {
					title: "職涯規劃",
					desc1: "剖析天賦優勢",
					desc2: "規劃成功路徑",
				},
				wealth: {
					title: "財富洞察",
					desc1: "掌握財運趨勢",
					desc2: "提升財富能量",
				},
				annual: {
					title: "年度運程",
					desc1: "流年運勢解析",
					desc2: "把握關鍵時機",
				},
				ziwei: {
					title: "紫微命盤",
					desc1: "紫微斗數精批",
					desc2: "命運格局解析",
				},
				bazi: {
					title: "八字精批",
					desc1: "四柱八字詳解",
					desc2: "命理全面分析",
				},
				tarot: {
					title: "塔羅占星",
					desc1: "塔羅牌指引",
					desc2: "結合占星洞察",
				},
				funTest: {
					title: "趣味測試",
					desc1: "豐富趣味測試",
					desc2: "探索內心想法",
				},
				more: {
					title: "更多測算",
					desc1: "探索更多工具",
					desc2: "解鎖人生答案",
				},
			},
		},
	},
	topTeacher: {
		title: "名師推薦",
		title2: "精選名師與熱門影片，助您探索生命智慧，掌握人生方向",
		viewProfile: "查看老師介紹",
		videoTitle: "熱門影片推薦",
		viewMoreVideos: "查看更多",
		viewUnit: "觀看",
		noVideos: "暫無視頻",
	},
	privilege: {
		title: "APP專屬福利",
		ctaTitle: "準備開始探索人生方向？",
		ctaDesc: "立即下載先知命局App，開啟屬於你的智慧之旅",
		downloadOn: "Download On The",
		apkLabel: "Download APK",
		features: {
			bean: {
				title1: "集福豆",
				title2: "贏大獎",
			},
			vip: {
				title1: "免費體驗",
				title2: "會員服務",
			},
			pray: {
				title1: "祈福台",
				title2: "每日祈福",
			},
			live: {
				title1: "導師直播Oncall",
				title2: "免費3分鐘",
			},
			meditation: {
				title1: "冥想空間",
				title2: "日常療癒",
			},
		},
	},
	sidebar: {
		ariaLabel: "快捷功能側邊欄",
		support: {
			title: "客戶支持",
			subtitle: "在線客服",
		},
		order: {
			title: "訂單查詢",
			subtitle: "查看訂單",
		},
		download: {
			title: "APP下載",
			subtitle: "掃碼下載",
		},
		top: {
			title: "Top",
			subtitle: "返回頂部",
		},
	},
	appDownloadModal: {
		title: "該功能暫未上線，請下載App搶先體驗",
		close: "關閉",
		back: "返回",
		goToApp: "前往App",
	},
};
